
    <label class="attachment" [ngClass]="{ active: dropPosition }">
      <div *ngIf="!dropPosition">
        <div class="text-ellipsis" *ngIf="filename">{{ filename }}</div>
        <div class="text-ellipsis" *ngIf="!filename"><ng-content></ng-content></div>
      </div>
      <div *ngIf="dropPosition"><div>Drop file here...</div></div>
      <input type="file" #input [name]="name" accept="{{ type }}" />
    </label>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/file-uploader.component.ts.FileUploaderComponent.html